import { Create, useForm } from '@refinedev/antd';
import { HttpError } from '@refinedev/core';
import { Form, Input, Select } from 'antd';
import type { PromptTemplate, PromptTemplateInput } from '@viq-admin/types';
import { PROMPT_PIPELINES, PIPELINE_LABELS, APPEND_BODY_MAX } from '../../api/promptStore';
import { MarkdownPromptEditor } from '../../components/MarkdownPromptEditor';
import { RequireCan } from '../../components/RequireCan';

/**
 * Create a reusable prompt template (global append snippet, mirrors
 * `ToolkitsCreate`'s shape — simplified: a single pipeline field replaces the
 * toolkit-type branching, and there are no secrets). `manage PromptTemplate`
 * gates the page.
 *
 * The body editor carries `data-testid="template-body"` — the "Name" field is
 * ALSO a plain textbox, so tests must scope into this wrapper rather than
 * relying on an unnamed-textbox role query.
 */
export function PromptTemplatesCreate() {
  const { formProps, saveButtonProps } = useForm<PromptTemplate, HttpError, PromptTemplateInput>({
    resource: 'prompt-templates',
    action: 'create',
  });
  return (
    <RequireCan I="manage" a="PromptTemplate">
      <Create saveButtonProps={saveButtonProps}>
        <Form {...formProps} layout="vertical" initialValues={{ pipeline: PROMPT_PIPELINES[0], body: '' }}>
          <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Name is required' }]}>
            <Input maxLength={200} />
          </Form.Item>
          <Form.Item label="Pipeline" name="pipeline" rules={[{ required: true }]}>
            <Select options={PROMPT_PIPELINES.map((p) => ({ label: PIPELINE_LABELS[p], value: p }))} />
          </Form.Item>
          <Form.Item label="Append body" name="body" rules={[{ required: true, message: 'Body is required' }]}>
            <MarkdownPromptEditor data-testid="template-body" max={APPEND_BODY_MAX} />
          </Form.Item>
        </Form>
      </Create>
    </RequireCan>
  );
}
